import React, { Component } from 'react';


class Web extends Component {
    render() {
        return (
            <div className="web col-md-12">


                <section id="banner" className="banner no-padding">




                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://petapp.freeoda.com/">http://petapp.freeoda.com/</a></h4>

                        <iframe src="http://petapp.freeoda.com/" title="fashionapp">
                        </iframe>

                    </div>




                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://sms.ueuo.com/">http://sms.ueuo.com/</a></h4>

                        <iframe src="http://sms.ueuo.com/" title="fashionapp">
                        </iframe>

                    </div>



                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://fashion-item.ueuo.com/">http://fashion-item.ueuo.com/</a></h4>

                        <iframe src="http://fashion-item.ueuo.com/" title="fashion-item">
                        </iframe>

                    </div>

                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://fashionapp.ueuo.com/">http://fashionapp.ueuo.com/</a></h4>

                        <iframe src="http://fashionapp.ueuo.com/" title="fashionapp">
                        </iframe>

                    </div>



                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://payment.freevar.com/">http://payment.freevar.com/</a></h4>

                        <iframe src="http://payment.freevar.com/" title="payment">
                        </iframe>

                    </div>




                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://3888.ueuo.com/">http://3888.ueuo.com/</a></h4>

                        <iframe src="http://3888.ueuo.com/" title="payment">
                        </iframe>

                    </div>




                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="https://www.sky3888a.com/?lang=my">https://www.sky3888a.com/?lang=my</a></h4>

                        <iframe src="https://www.sky3888a.com/?lang=my" title="payment">
                        </iframe>

                    </div>









                    <div className="col-md-6  web_textstyle">

                        <h4 className="web_linktext"><a href="http://webcashgame.stargt.com.my/en">http://webcashgame.stargt.com.my/en</a></h4>

                        <iframe src="http://webcashgame.stargt.com.my/en" title="fashionapp">
                        </iframe>

                    </div>








                </section>



            </div>
        );
    }
}

export default Web;



// WEBPACK FOOTER //
// ./src/page/web/Web.js